import { combineReducers } from "redux";
import authReducer from "./auth.reducer";

const rootReducer = combineReducers({
    permissions: authReducer
});

export default rootReducer;